import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
import LinkButton from 'flarum/common/components/LinkButton';
import CommentPost from 'flarum/forum/components/CommentPost';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import ProductPickerModal from './components/ProductPickerModal';
import { hydrateProducts } from './hydrateProducts';
import { cart } from './shop';
export { default as extend } from './extend';
app.initializers.add('abdulrehman-shop', () => {
  // Composer button for vendors
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    if (!app.forum.attribute('canSellProducts')) return;
    items.add('shopProduct', m(TextEditorButton, {
      icon: "fas fa-store",
      onclick: () => app.modal.show(ProductPickerModal)
    }, "Add product"));
  });

  // Product cards inside posts
  extend(CommentPost.prototype, ['oncreate', 'onupdate'], function () {
    hydrateProducts(this.element);
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    const count = cart.count();
    if (!count) return;
    items.add('shopCart', m(LinkButton, {
      className: "Button Button--link",
      icon: "fas fa-shopping-cart",
      href: app.route('abdulrehman-shop.checkout')
    }, "Cart (", count, ")"), 15);
  });
  extend(SessionDropdown.prototype, 'items', function (items) {
    if (!app.forum.attribute('canSellProducts')) return;
    items.add('shopVendor', m(LinkButton, {
      icon: "fas fa-store",
      href: app.route('abdulrehman-shop.vendor')
    }, "My products"), 90);
  });
});